import { render, staticRenderFns } from "./createEditAction.vue?vue&type=template&id=21b50336"
import script from "./createEditAction.vue?vue&type=script&lang=js"
export * from "./createEditAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports